import { render, staticRenderFns } from "./EudrDetailDialog.vue?vue&type=template&id=e36af48e&scoped=true&"
import script from "./EudrDetailDialog.vue?vue&type=script&lang=js&"
export * from "./EudrDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./EudrDetailDialog.vue?vue&type=style&index=0&id=e36af48e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36af48e",
  null
  
)

export default component.exports